require('../controls/smartSuggest');

/* Smart Suggest Service */
var SmartSuggestService = function () {
    var currentContext = $(document);
    var moduleOptions = {
        url: ''
    };

    function initSmartSuggest() {
        if (currentContext.length) {
            currentContext.smartSuggest({
                src: moduleOptions.url,
                resultsText: '',
                minChars: 2,
                fillBox: true
            });
        }
    }

    this.init = function (context, options) {
        currentContext = context || currentContext;
        $.extend(moduleOptions, options);

        initSmartSuggest();
    };

    return this;
};

module.exports = SmartSuggestService;
